// ABOUTME: Notifications sheet hook using global dialog store
// ABOUTME: Manages notifications drawer state and scroll offset for virtual keyboard

import { useState } from "react";

import { useGlobalDialogs } from "@/shared/model/global-dialogs";

const DIALOG_ID = "notifications";

export function useNotificationsSheet() {
  const { isOpen, open: openDialog, close } = useGlobalDialogs();
  const [scrollOffset, setScrollOffset] = useState(0);

  return {
    isOpen: isOpen(DIALOG_ID),
    setIsOpen: (open: boolean) => (open ? openDialog(DIALOG_ID) : close()),
    open: () => openDialog(DIALOG_ID),
    close,
    scrollOffset,
    setScrollOffset,
  };
}
